/**
 * Draft Transfers Fragment
 * Handles pagination interactions for the draft transfers list.
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

const TransferDraftHandlers = {
    onGotoPage(e, element) {
        const offset = element.dataset.offset;
        const container = element.closest('#drafts-transfers');
        if (!container) return;

        const form = container.querySelector('form');
        const startInput = container.querySelector('#pagination-start');
        if (form && startInput) {
            startInput.value = offset;
            form.requestSubmit();
        }
    },
};

export function initTransferDraft() {
    if (initialized) return;
    initialized = true;

    Events.on('click', 'transfer-draft-goto-page', (e, element) => {
        TransferDraftHandlers.onGotoPage(e, element);
    });

    console.log('[LeapFILE] Draft transfers fragment initialized');
}
